var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useGenres } from "frontend/src/domain/genres";
import { useUpdateTracks } from "frontend/src/domain/tracks/actions";
import { useEffect, useMemo, useState } from "react";
export var useChangeTracksGenres = function (_a) {
    var checkedTracksIds = _a.checkedTracksIds, initialGenreIds = _a.initialGenreIds;
    var _b = useGenres(), genres = _b.genres, isFetching = _b.isFetching;
    var initialChecked = useMemo(function () {
        return (initialGenreIds !== null && initialGenreIds !== void 0 ? initialGenreIds : []).reduce(function (acc, id) {
            var _a;
            return (__assign(__assign({}, acc), (_a = {}, _a[id] = true, _a)));
        }, {});
    }, [initialGenreIds === null || initialGenreIds === void 0 ? void 0 : initialGenreIds.join(",")]);
    var _c = useState(initialChecked), checked = _c[0], setChecked = _c[1];
    useEffect(function () {
        setChecked(initialChecked);
    }, [initialChecked]);
    var checkedGenresIds = Object.keys(checked).map(function (id) { return parseInt(id); });
    var toggleById = function (id) {
        var _a;
        if (checked[id]) {
            setChecked(function (_a) {
                var _b = id, _ = _a[_b], rest = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
                return rest;
            });
        }
        else {
            setChecked(__assign((_a = {}, _a[id] = true, _a), checked));
        }
    };
    var updateGenres = useUpdateTracks();
    var resetUpdateState = function () {
        var _a;
        (_a = updateGenres.reset) === null || _a === void 0 ? void 0 : _a.call(updateGenres);
        setChecked(initialChecked);
    };
    var updateTracksGenres = function () {
        return updateGenres.do(checkedTracksIds.map(function (trackId) { return ({
            id: trackId,
            genres: checkedGenresIds,
        }); }));
    };
    var checkedGenres = genres === null || genres === void 0 ? void 0 : genres.map(function (genre) { return (__assign(__assign({}, genre), { isChecked: genre.id in checked })); });
    return {
        genres: checkedGenres,
        toggleById: toggleById,
        isFetching: isFetching,
        updateTracksGenres: updateTracksGenres,
        resetUpdateState: resetUpdateState,
        isUpdating: updateGenres.isLoading,
        isSuccess: updateGenres.isSuccess,
    };
};
